/**
 * Fix: Force Splide AutoScroll to pause on hover
 * Fixes Mac Chrome trackpad momentum issue
 * Safe override – does NOT modify Splide internals
 */
(function () {
  function applyHoverPauseFix(root = document) {
    if (!window.slideshows) return;

    root.querySelectorAll(".splide").forEach((slider) => {
      if (!slider.id) return;

      const instance = window.slideshows[slider.id];
      if (!instance || !instance.Components) return;

      const autoScroll = instance.Components.AutoScroll;
      if (!autoScroll) return;

      // Prevent duplicate bindings
      if (slider.dataset.hoverPauseBound === "true") return;
      slider.dataset.hoverPauseBound = "true";

      slider.addEventListener("mouseenter", () => {
        autoScroll.pause(true); // hard pause
      });

      slider.addEventListener("mouseleave", () => {
        autoScroll.play();
      });
    });
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", () => {
    applyHoverPauseFix(document);
  });

  // Re-apply when sections reload dynamically
  document.addEventListener("shopify:section:load", (e) => {
    applyHoverPauseFix(e.target);
  });

  document.addEventListener("cart:updated", () => {
    applyHoverPauseFix(document);
  });
})();
